import { render, staticRenderFns } from "./ClientAccountingSummaryTab.vue?vue&type=template&id=38dabd4a&"
import script from "./ClientAccountingSummaryTab.vue?vue&type=script&lang=js&"
export * from "./ClientAccountingSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports